export default __webpack_public_path__ + "static/media/gallery_03.09d138e4.jpg";